import { styled as e, css as s } from "styled-components";
import { MediaQuery as i } from "../../styles/variables.js";
import { H1Heavy as t, H3Heavy as n, BodyHeavy as d, BodyLight as p, H3Light as l } from "../../styles/typography/index.js";
import { Button as c } from "../Button/index.js";
import { CouponStamp as m } from "../CouponStamp/index.js";
import { Skeleton as g } from "../Skeleton/index.js";
import { Theme as o } from "../../styles/themes/index.js";
import { ArrowUpRightFromSquare as $ } from "@pelando/fontawesome/icons";
const _ = e(m)`
  color: rgb(${o.colors.Alpha});
  ${t}
  min-width: 124px;
  span {
    ${t}
    ${({ valueStyle: a }) => a || ""}
  }

  small {
    ${n}
  }
`, S = e.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${o.spacings[4]};
  background-color: rgb(${o.colors.Juliet});
  border-radius: ${o.spacings[4]};
  border: 1px solid rgb(${o.colors.Golf});

  @media ${i.SCREEN_MD_UP} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: ${o.spacings[2]};
    padding: ${`${o.spacings[6]} ${o.spacings[4]}`};
  }
`, r = s`
  ${n};
  background: unset;
  color: rgb(${o.colors.Alpha});
  text-decoration: line-through;
  word-break: break-all;
`, w = e.button`
  ${r}
  margin-top: ${o.spacings[1]};
  width: 100%;
  ${d}

  @media ${i.SCREEN_MD_UP} {
    display: none;
  }
`, v = e.div`
  display: flex;
  align-items: center;
  align-self: start;

  @media ${i.SCREEN_MD_UP} {
    justify-content: unset;
  }
`, R = e.p`
  ${p}
  color: rgb(${o.colors.Alpha});
  text-align: left;
  text-decoration: none;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media ${i.SCREEN_MD_UP} {
    ${l}
  }
`, D = e.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: ${o.spacings[2]};
  width: 100%;

  @media ${i.SCREEN_MD_UP} {
    margin-left: ${o.spacings[4]};
  }
`, M = e.button`
  ${r}
  display: none;

  @media ${i.SCREEN_MD_UP} {
    display: flex;
  }
`, P = e.div`
  display: flex;
  justify-content: center;
  width: 100%;

  @media ${i.SCREEN_MD_UP} {
    margin-left: ${o.spacings[4]};
    max-width: 298px;
  }
`;
e.div``;
const U = e(c).attrs({
  responsive: !0,
  inactive: !0,
  icon: $,
  iconPosition: "right"
})`
  margin-top: ${o.spacings[2]};

  @media ${i.SCREEN_MD_UP} {
    margin-top: 0px;
  }
`, k = e(g)`
  width: 100%;
  border-radius: ${o.spacings[4]};
  height: 136px;

  @media ${i.SCREEN_MD_UP} {
    border-radius: ${o.spacings[2]};
  }
`;
export {
  S as Container,
  v as ExpiredCouponCardHeaderContainer,
  D as ExpiredCouponCardHeaderContentWrapper,
  P as ExpiredCouponCardRightCornerContainer,
  _ as ExpiredCouponCardStamp,
  w as ExpiredCouponCodeHeaderButton,
  M as ExpiredCouponCodeRightCornerButton,
  R as ExpiredCouponTitle,
  U as SeeDealButton,
  k as SkeletonContainer
};
